module.exports = __webpack_public_path__ + "static/media/IlotD_synthese_12.88041fff.webp";